import { cn } from "@/lib/utils";

// Cabeçalho de página reutilizável: breadcrumb, título, descrição, ações.
export const PageHeader = ({ title, description, breadcrumb, actions, icon: Icon, className }) => {
  return (
    <div className={cn("flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between", className)}>
      <div className="min-w-0">
        {breadcrumb && <div className="mb-2 flex items-center gap-1.5 text-xs text-muted-foreground">{breadcrumb}</div>}
        <div className="flex items-center gap-3">
          {Icon && (
            <div className="flex h-10 w-10 items-center justify-center rounded-lg border border-line bg-surface text-brand">
              <Icon className="h-5 w-5" />
            </div>
          )}
          <div className="min-w-0">
            <h1 className="font-heading text-2xl font-bold tracking-tight text-foreground sm:text-3xl">{title}</h1>
            {description && <p className="mt-1 text-sm text-muted-foreground text-balance">{description}</p>}
          </div>
        </div>
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
};
